import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Icon, Text, Link } from 'roo-ui/components';
import formatPropertyAddress from 'components/formatters/FormatPropertyAddress';
import { useDataLayer } from 'hooks/useDataLayer';

const GOOGLE_MAP_DIRECTIONS_URL = 'http://www.google.com/maps/dir/?api=1&';

const GetDirections = React.memo(({ address }) => {
  const { emitInteractionEvent } = useDataLayer();

  const destination = formatPropertyAddress({
    streetAddressLines: address.streetAddress,
    suburb: address.suburb,
    state: address.state,
    country: address.country,
  });
  const href = `${GOOGLE_MAP_DIRECTIONS_URL}destination=${destination}&travelmode=driving`;

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Directions Pop Up', value: `Get Directions Link Selected` });
  }, [emitInteractionEvent]);

  return (
    <Box>
      <Link
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        onClick={handleOnClick}
        color="red"
        textDecoration="none"
        aria-label="Get directions on Google Maps"
      >
        <Text>Get directions</Text>
        <Icon name="chevronRight" size={16} />
      </Link>
    </Box>
  );
});

GetDirections.propTypes = {
  address: PropTypes.object.isRequired,
};

export default GetDirections;
